<template>
  <v-main>
    <div class="favorites-list">
      <div>
        <v-text-field v-model="new_list_name" placeholder="Enter the list name"></v-text-field>
        <v-btn  :disabled="new_list_name === ''" @click ="addElementToList"
        >Create a new favorite list
        </v-btn>
      </div>
      <FavoriteList v-for="(favorite, index) in favorites_list" :key="index"
                    :ref="index"
                    :child_number="index"
                    :favorite_list="favorite"
                    :restaurants-list="restaurantsList"
                    :on-add-restaurant-to-list="onAddRestaurantToList"
                    :on-delete-restaurant-from-list="onDeleteRestaurantFromList"
                    @updateList="updateList"
                    @deleteList="deleteList"
      />
      <div v-if="favorites_list.length === 0">
        No created favorites list yet
      </div>
    </div>
  </v-main>
</template>

<script>
import FavoriteList from "@/components/Favorites/FavoriteList";

export default {
  name: "UserFavorites",
  components: {
    FavoriteList
  },
  data(){
    return {
      new_list_name:"",
    }
  },
  props: [
    'favorites_list',
    'restaurantsList',
    'onCreateFavoriteList',
    'onDeleteFavoriteList',
    'onUpdateFavoriteList',
    'onAddRestaurantToList',
    'onDeleteRestaurantFromList',
  ],

  methods:{
    async deleteList(payload){
      await this.onDeleteFavoriteList(payload.id)
      this.$refs[payload.index][0].destroyElement();
    },

    async updateList(payload){
      await this.onUpdateFavoriteList(payload.id, payload.name)
      this.$eventHub.$emit('reloadAll')
    },
    async addElementToList(){
      if(this.new_list_name !== "") {
        await this.onCreateFavoriteList(this.new_list_name);
        this.$eventHub.$emit('reloadAll')
      }
    }
  },

}
</script>

<style scoped>
.favorites-list{
  -webkit-box-shadow: 0 0 10px grey;
  box-shadow: 0 0 10px grey;
  padding: 3vh;
  margin: 2vh;
  border-radius: 6px;
  width: 90vw;
}
</style>
